var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContact48 = function SvgContact48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contact_48_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".contact_48_svg__st0{fill:#393839}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "contact_48_svg__st0",
    d: "M32.1 23c0 .3.3.6.6.6s.6-.3.6-.6c0-4.8-3.9-8.8-8.8-8.8-.3 0-.6.3-.6.6s.3.6.6.6c4.2 0 7.6 3.4 7.6 7.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "contact_48_svg__st0",
    d: "M23.6 8.8c-.3 0-.6.3-.6.6s.3.6.6.6c7.6 0 13.8 6.2 13.8 13.8 0 .3.3.6.6.6s.6-.3.6-.6c.1-8.2-6.7-15-15-15zM28.2 26c-.4 0-.9.1-1.3.2l-.3.1-.2.3c-.8.9-1.4 1.8-2 3.4-1.5-.8-2.9-1.8-4.2-3-1.3-1.3-2.3-2.7-3-4.2 1.5-.6 2.5-1.2 3.4-2l.3-.2.1-.3c.8-3.1-1.8-7.4-4.5-8.9L16 11h-.3c-3.3 0-7 4.2-7.1 7.2v.2c.5 3.6 3.3 8.4 7.4 12.5 4.2 4.2 8.9 7 12.5 7.4h.2c2.9-.1 7.2-3.8 7.2-7.1v-.3l-.2-.3c-1.3-2.4-4.8-4.6-7.5-4.6zm.9 11.3c-3.2-.4-7.8-3-11.8-7.1-4.1-4.1-6.7-8.6-7.1-11.8.1-2.4 3.3-6 5.9-6 2.4 1.3 4.6 5.1 3.9 7.5-1 .9-2 1.6-4.2 2.2.7 1.9 1.9 3.9 3.8 5.8s3.9 3.1 5.8 3.8c.6-2.2 1.3-3.2 2.2-4.2.3-.1.6-.1.9-.1 2.4 0 5.4 1.9 6.6 4.1 0 2.5-3.6 5.7-6 5.8z"
  })));
};
export default SvgContact48;